import HouseholdComponent from './household.js';
import './App.css';
import { useState, useEffect, } from 'react';
import logo from './village.jpeg';
import { v4 as uuidv4 } from 'uuid';

const HouseholdPage = () => {
  const query = window.location.search;
  const params = new URLSearchParams(query);
  const [familyData, setFamilyData] = useState('');
  useEffect(() => {
    const getHouseholdCall = async () => {
      try {

        const householdResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/household?shareToken=` + params.get('shareToken'), {
          method: 'GET',
          credentials: 'include'
        });

        if (householdResponse.status === 200) {
          const householdJson = await householdResponse.json();
          setFamilyData(householdJson);
        } else {
          console.error("Error getting household data");
        }
      } catch (error) {
        console.error('Error getting household data:', error);
      }
    };

    getHouseholdCall();
  }, []); // Pass an empty array as the dependency list to run the effect only on mount

  console.log(params.get('shareToken'));

  return (
    <div className="App">
      <div className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </div>
      <div className="App-body App-body-center">
        <div>
          {familyData ? <HouseholdComponent key={uuidv4()} data={familyData} ownHousehold={false} /> : <p>Loading...</p>}
        </div>
      </div>
    </div>
  );
}

export default HouseholdPage;

// 
//  https://koy.parent-ai.com/showHousehold/?shareToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2ODAwNjE4OTUsImlkIjoiYzYwMTkzODMtMjdlYS00MTk4LTljMDEtNWY5MjA4ZDkwZTAzIn0.44zyLmDolMumN2BS0elcqj-oCGjo41WULbjJPF3zN80